/**
 * Function to set elements height to the height of the heighest
 *
 * @param className - CSS Selector for all elements, that shall be set to the same max-height
 *
 * @author Daniel Witt
 */
function setEqualHeightsMax(className) {
    const elements = document.querySelectorAll(className);
    if (!elements.length) return;

    // Reset heights to auto to recalculate properly
    elements.forEach(el => el.style.height = 'auto');

    let maxHeight = 0;

    elements.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    elements.forEach(el => {
        el.style.height = `${maxHeight}px`;
    });
}

/**
 * Function to set elements height to the height of the smallest
 *
 * @param className - CSS Selector for all elements, that shall be set to the same min-height
 *
 * @author Daniel Witt
 */
function setEqualHeightsMin(className) {
    const elements = document.querySelectorAll(className);
    if (!elements.length) return;

    let minHeight = Infinity;

    elements.forEach(el => {
        const height = el.offsetHeight;
        if (height < minHeight) {
            minHeight = height;
        }
    });

    // Reset heights to auto to recalculate properly
    elements.forEach(el => el.style.height = 'auto');

    elements.forEach(el => {
        el.style.height = `${minHeight}px`;
    });
}

/**
 * Video VC element: hide the loading spinner once the video is ready
 * (or if it errors out), so it doesn't spin forever.
 *
 * @author Daniel Witt
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-video-element').forEach(function (wrap) {
        const video = wrap.querySelector('video');
        if (!video) return;

        const markLoaded = function () {
            wrap.classList.add('is-loaded');
        };

        // Already ready (e.g. cached)? readyState >= 1 means metadata is available.
        if (video.readyState >= 1) {
            markLoaded();
            return;
        }

        ['loadeddata', 'loadedmetadata', 'canplay', 'playing', 'error'].forEach(function (evt) {
            video.addEventListener(evt, markLoaded, { once: true });
        });
    });
});

/**
 * Script for job offering accordion
 *
 * @author Fuad Mamadov
 */
jQuery(document).ready((function () {
    jQuery('[class*="stellenanzeige_akkordeon_header_button-"]').click((function () {
        var e = this.classList.toString().split("-")[1];
        let t = document.getElementById("stellenanzeige_akkordeon_arrow-" + e);
        "false" === this.dataset.open ? (t.style.transform = "rotate(180deg)", jQuery(".stellenanzeige_akkordeon_content-" + e).show(500), this.dataset.open = "true") : (t.style.transform = "unset", jQuery(".stellenanzeige_akkordeon_content-" + e).hide(500), this.dataset.open = "false")
    }))
}))